import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/partner/$organization/v2-pending-subscriptions/$subscriptionId/')({
  component: () => (
    <Navigate
      replace
      search
      from="/partner/$organization/v2-pending-subscriptions/$subscriptionId/"
      to="/bo/subscriptions/$subscriptionId"
    />
  ),
})
